export default __webpack_public_path__ + "static/media/approved-pariuri.256424f0.svg";